import React, { useState } from 'react';
import { Column } from 'primereact/column';
import { CustomTable } from './../../components/Table/CustomTable';
import { ToolBarThreeColumns } from './../../components/Table/ToolBarThreeColumns';
import { FilterMatchMode } from 'primereact/api';
import { headerClassName } from '../../assets/customStyles';
import data from './data.json';

export const VacationScreen = () => {
	const [sort, setSort] = useState([{ field: '', order: -1 }]);
	const [selectedRows, setSelectedRows] = useState(null);
	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
	});
	const [filterOpc] = useState({
		status: [
			{
				label: 'Todos',
				value: 0,
			},
			{
				label: 'Respondido',
				value: 1,
			},
			{
				label: 'Cancelado',
				value: 2,
			},
			{
				label: 'Enviado',
				value: 3,
			},
			{
				label: 'Completado',
				value: 4,
			},
		],
	});
	const [selectFilter, setSelectFilter] = useState({
		status: 0,
	});

	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const [startDateValue, setStartDateValue] = useState(new Date());
	const [endDateValue, setEndDateValue] = useState(new Date());

	const onGlobalFilterChange = (e) => {
		const { value } = e.target;
		const _filters = { ...filters };
		_filters.global.value = value;
		setFilters(_filters);
		setGlobalFilterValue(value);
	};

	const handleFilterChange = (e) => {
		const { name, value } = e.target;
		setSelectFilter({
			...selectFilter,
			[name]: value,
		});
	};

	const renderHeader = () => (
		<ToolBarThreeColumns
			value={globalFilterValue}
			setValue={setGlobalFilterValue}
			setFilters={setFilters}
			onChange={onGlobalFilterChange}
			placeholder={'Buscar'}
			iNeedStartDate
			iNeedEndDate
			startDateValue={startDateValue}
			setStartDateValue={setStartDateValue}
			endDateValue={endDateValue}
			setEndDateValue={setEndDateValue}
			filterOpc={filterOpc}
			selectFilter={selectFilter}
			handleFilterChange={handleFilterChange}
		/>
	);

	const renderDataTable = () => {
		const bodyClassName =
			'!border-r-2 !border-b-0 !border-secondary-PCS004 !text-secondary-PCS001';
		return (
			<CustomTable
				value={data}
				loading={false}
				header={renderHeader()}
				selection={selectedRows}
				onSelectionChange={(e) => setSelectedRows(e.value)}
				filters={filters}
				responsiveLayout='scroll'
				emptyMessage={'No hay datos para mostrar'}
				currentPageReportTemplate={
					'Mostrando {first} a {last} de {totalRecords} Vacaciones'
				}
				style={{ height: '100%', width: '100%' }}
				setSort={setSort}
				sort={sort}>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='codeCollaborator'
					header={'Código'}
					sortable
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='nameCollaborator'
					header={'Colaborador'}
					sortable
					bodyClassName={bodyClassName}
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='nameLeader'
					header={'Líder'}
					sortable
					bodyClassName={bodyClassName}
				//align='center'
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='dateOfApplication'
					header={'Fecha de solicitud'}
					sortable
					bodyClassName={bodyClassName}
				//align='center'
				/>
				<Column
					headerClassName={headerClassName} //'hover:!text-success !border-border !border-r !break-words'
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='startDate'
					header={'Fecha de inicio'}
					sortable
					bodyClassName={bodyClassName}
				//	align='center'
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='endDate'
					header={'Fecha de fin'}
					sortable
					bodyClassName={bodyClassName}
				//align='center'
				/>
				<Column
					headerClassName={headerClassName}
					style={{ flexGrow: 1, flexBasis: '100px' }}
					field='status'
					header={'Status'}
					sortable
					bodyClassName={bodyClassName}
				//align='center'
				/>
			</CustomTable>
		);
	};
	return (
		<div className='flex w-full h-full relative flex-col'>
			<div className='flex w-full h-[5%] justify-center content-center items-center p-1'>
				<div className='flex justify-start content-center items-center w-full h-full rounded-md'>
					<h1 className='text-2xl font-bold'>{'Vacaciones'}</h1>
				</div>
			</div>
			<div className='flex w-full h-[95%] relative  '>
				<div className='flex w-full h-full content-center items-center justify-center flex-row '>
					{renderDataTable()}
				</div>
			</div>
		</div>
	);
};
